export const INBOUND_SHIPMENT_COLUMN_DEFS = [
  { key: 'products', title: 'Products', width: 168 },
  { key: 'shipment', title: 'Shipment', width: 200 },
  { key: 'contents', title: 'Contents', width: 160 },
  { key: 'route', title: 'Route', width: 220 },
  { key: 'status', title: 'Status', width: 160 },
] as const;

export type InboundShipmentColumnKey =
  (typeof INBOUND_SHIPMENT_COLUMN_DEFS)[number]['key'];
